import { useParams, useLocation } from 'react-router-dom';
import getSubmissionsAppRoute from 'forms-utils-lib/urls/submissions/getSubmissionsAppRoute';
const RedirectToSubmissions = props => {
  const {
    tab
  } = props;
  const {
    formGuid
  } = useParams();
  const location = useLocation();
  const submissionsUrl = getSubmissionsAppRoute(formGuid, tab);
  window.location.replace(`${submissionsUrl}/${location.search}`);
  return null;
};
export default RedirectToSubmissions;